import React from "react";
import { Link } from "react-router-dom";

const About: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-6">
          About Workman Naija
        </h1>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-6">
          <p>
            Workman Naija connects customers across Nigeria with local
            handymen and service providers — electricians, plumbers,
            carpenters, cleaners and dozens of other trades — so you can find
            someone trustworthy without relying on word of mouth alone.
          </p>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              What we do
            </h2>
            <p>
              Search by state, local government area and service to see
              providers near you, compare ratings and reviews from past
              customers, and book directly through the platform. Payments are
              handled securely through Paystack.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              For providers
            </h2>
            <p>
              If you're a skilled tradesperson or run a service business,
              you can list your business for free, reach customers actively
              searching in your area, and build a track record through
              verified reviews.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Get started
            </h2>
            <p>
              <Link to="/search" className="text-green-700 hover:underline">
                Find a handyman
              </Link>{" "}
              or{" "}
              <Link
                to="/register-provider"
                className="text-green-700 hover:underline"
              >
                list your business
              </Link>{" "}
              today.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
